import { render } from "./OrderText.vue?vue&type=template&id=98cf7830&scoped=true"
import script from "./OrderText.vue?vue&type=script&lang=ts"
export * from "./OrderText.vue?vue&type=script&lang=ts"

import "./OrderText.vue?vue&type=style&index=0&id=98cf7830&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-98cf7830"

export default script